import { render, staticRenderFns } from "./issued.vue?vue&type=template&id=06e315b8&scoped=true&"
import script from "./issued.vue?vue&type=script&lang=js&"
export * from "./issued.vue?vue&type=script&lang=js&"
import style0 from "./issued.vue?vue&type=style&index=0&id=06e315b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e315b8",
  null
  
)

export default component.exports